<template>
  <div class="p-d-flex p-flex-wrap p-ai-center">
    <div v-if="notificationState"
         v-tooltip.top="notificationTooltip"
         class="state-badge"
         :class="[{ 'small-state-badge': isSmall }, notificationStateColor]">
      {{ notificationStateLabel }}
    </div>
  </div>
</template>

<script>
import NotificationStates from "@/translations/states/NotificationStates";
import formatMixins from "@/mixins/formatMixins";
export default {
  mixins: [ formatMixins ],
  name: 'NotificationStatus',
  props: {
    item: {
      type: [Object, null],
      default: null
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      NotificationStates
    }
  },
  computed: {
    notificationTooltip() {
      if (Number(this.stateId) !== 3 || !this.item?.sms_sent_at) {
        return null
      }

      return `${this.$t('sentAtLabel')}: ${this.formatDate(this.item.sms_sent_at, true)}`
    },
    stateId() {
      if (!this.item) return null

      const isProcessed = !!this.item.is_processed
      const smsSentAt = this.item.sms_sent_at
      const due = Number(this.item.need_to_send_due || 0)

      if (!isProcessed) {
        if (!smsSentAt && due > 0 && due * 1000 < Date.now()) {
          return 5
        }

        return 1
      }

      return smsSentAt ? 3 : 7
    },

    notificationState() {
      return this.NotificationStates.find(state => Number(state.id) === Number(this.stateId)) || null
    },

    notificationStateLabel() {
      return this.notificationState?.label?.[this.$i18n.locale] || this.notificationState?.label?.en || ''
    },

    notificationStateColor() {
      return this.notificationState?.color || ''
    }
  }
}
</script>
<style scoped lang="scss">
.small-state-badge {
  font-size: 0.8rem;
}
</style>